import CommonModal from "../modalLayout/CommonModal";
import FileUploadBox from "../fileUpload/FileUploadBox";
import { PRESCRIPTION_UPLOAD_ACCEPT } from "../../../helpers/prescriptionFormat";

const UploadPrescriptionModal = ({ show, setShow, setUploadedFile }) => {
  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title="Upload prescription file"
      centered
      onConfirm={() => setShow(false)}
    >
      <FileUploadBox
        setUploadedFile={setUploadedFile}
        acceptedFormats={PRESCRIPTION_UPLOAD_ACCEPT}
      />
    </CommonModal>
  );
};

export default UploadPrescriptionModal;
